module.exports = __webpack_public_path__ + "static/media/HeroRiceBowl.7245a813.jpg";